export const CONTENT_TYPES = {
  scenario: "scenario",
  trainer: "trainer",
};

export function resolveGameContentType(game, options = {}) {
  if (!game) return CONTENT_TYPES.scenario;

  const { trainerHint = false } = options;

  if (game.contentType === CONTENT_TYPES.trainer) return CONTENT_TYPES.trainer;
  if (game.settings?.contentType === CONTENT_TYPES.trainer) {
    return CONTENT_TYPES.trainer;
  }
  if (game.trainerTheme) return CONTENT_TYPES.trainer;
  if (Array.isArray(game.trainerQuestions) && game.trainerQuestions.length > 0) {
    return CONTENT_TYPES.trainer;
  }
  if (trainerHint) return CONTENT_TYPES.trainer;

  return game.contentType || game.settings?.contentType || CONTENT_TYPES.scenario;
}

export function isTrainerGame(game, options = {}) {
  return resolveGameContentType(game, options) === CONTENT_TYPES.trainer;
}

export function getContentTypeLabel(contentType) {
  return contentType === CONTENT_TYPES.trainer ? "Тренажёр" : "Сценарий";
}

export function getMaxButtonsForGame(game) {
  return isTrainerGame(game) ? 4 : 2;
}
